import React from "react";
import ProviderOverview from "../kyb-common-components/provider-overview";

const Handelsregister = () => {
    return <ProviderOverview provider="handelsregister" />;
};

export default Handelsregister;
